let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hj5jD")).then(() => parcelRequire('inoGB'));